import { Stack, InputAdornment, TextField } from '@mui/material';
import debounce from 'lodash/debounce';
import React from 'react';
import Iconify from '../../components/Iconify';
interface IProps {
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  compact?: boolean;
}

const searchInputProps = {
  startAdornment: (
    <InputAdornment position='start'>
      <Iconify
        icon={'eva:search-fill'}
        sx={{ color: 'text.disabled', width: 20, height: 25 }}
      />
    </InputAdornment>
  ),
};

const Index: React.FC<IProps> = ({ handleSearch, compact = false }) => {
  const handleSearchByDebounce = debounce(handleSearch, 700);

  if (compact) {
    return (
      <TextField
        fullWidth
        size="small"
        onChange={handleSearchByDebounce}
        placeholder="Search..."
        InputProps={searchInputProps}
      />
    );
  }

  return (
    <Stack
      spacing={2}
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ py: 2.5, px: 3 }}
    >
      <TextField
        fullWidth
        onChange={handleSearchByDebounce}
        placeholder='Search...'
        InputProps={searchInputProps}
      />
    </Stack>
  );
};

export default Index;
